<template>
    <label>
        <input
            type="checkbox"
            class="def-checkbox"
            :required="required"
            @invalid.prevent="handlerInvalid"
            @change="handlerBlur"
            checked="checked"
        >
        <span>
            <slot />
            <br>
            <SlideUpDown :modelValue="!isValid">
                <span class="def-checkbox__invalid">{{ invalidText }}</span>
            </SlideUpDown>
        </span>
    </label>
</template>

<script>
export default {
    name: 'def-checkbox',
    selector: '.def-checkbox',
    props: ['required', 'invalidText', 'checked'],
    data() {
        return {
            isValid: true,
        }
    },
    methods: {
        handlerInvalid() {
            this.isValid = false;
        },
        handlerBlur({target}) {
            // console.log(target.checked);
            // if (target.checkValidity()) {
            //     this.isValid = true;
            // }
            this.isValid = target.checked;
            // this.$emit('blur', target.value);
        }

    }
}
</script>

<style lang="scss" scoped>
.def-checkbox{
    &__invalid{
        display: inline-block;
        color: #C80024;
        margin-top: 4px;
    }
}
</style>